import ObjetoTiempos from "./ObjetoTiempos";
import UC from "./UC";

export default class UE {

    static getLink(tipo, id) {
        let link = "https://jchessmanager.web.app/";
        if (tipo === 0) {
            link = link + "v/"
        } else if (tipo === 1) {
            link = link + "t/"
        } else if (tipo === 2) {
            link = link + "p/"
        }

        link = link + id;

        return link;
    }

    static getFecha() {
        var d = new Date(),
            dformat = [d.getFullYear(), this.agregarCero(d.getMonth() + 1), this.agregarCero(d.getDate())].join('-') + ' ' +
                [this.agregarCero(d.getHours()),
                this.agregarCero(d.getMinutes()),
                this.agregarCero(d.getSeconds())].join(':');
        //=> dformat => '05/17/2012 10:52:21'
        return dformat;
    }

    static getFechaAMD(fecha) {
        let res = ""
        try {
            let lista = String(fecha).split(" ");
            res = String(lista[0]).replace(/-/g, "/");
        } catch (e) {

        }
        //console.log("FECHAAMDDDDDDDDDDDDDDDDD", res);
        return res;
    }

    static agregarCero(numero) {
        //console.log("tipo", typeof(numero))
        var res = numero;
        if (numero < 10) {
            res = "0" + numero
        }
        return res;
    }

    static getListadoPerfilRecords(datos) {
        //{{posCat:0, single: obj, average: obj}}

        let tiemposPerfil = [];

        for (const key in datos) {
            if (datos.hasOwnProperty(key)) {
                const objetoTiempos = ObjetoTiempos.crarDesdeJSON(datos[key]);
                //console.log(`Clave: ${key}, Valor: ${objetoTiempos.toString()}`);

                let posAct = UC.getPosCatSingle(key);
                if (posAct >= 0) {
                    let insertado = false;

                    tiemposPerfil.forEach(tiempoPerfil => {
                        if (tiempoPerfil.posCat === posAct) {
                            tiempoPerfil.single = objetoTiempos;
                            insertado = true;
                        }
                    });

                    if (!insertado) {
                        tiemposPerfil.push({ posCat: posAct, single: objetoTiempos })
                    }

                } else {
                    posAct = UC.getPosCatAverage(key);
                    if (posAct >= 0) {
                        let insertado = false;

                        tiemposPerfil.forEach(tiempoPerfil => {
                            if (tiempoPerfil.posCat === posAct) {
                                tiempoPerfil.average = objetoTiempos;
                                insertado = true;
                            }
                        });

                        if (!insertado) {
                            tiemposPerfil.push({ posCat: posAct, average: objetoTiempos })
                        }

                    }
                }

            }
        }

        tiemposPerfil.sort((a, b) => a.posCat - b.posCat);

        return tiemposPerfil;
    }
}